import React from 'react';
import MenuAlumno from '../components/MenuAlumno';

export default function UsuarioDashboard() {
  return (
    <>
      <MenuAlumno />
      <div className="p-6">
        <h2 className="text-2xl font-bold">👋 Bienvenido, usuario</h2>
        <p>Acá podrás ver tus rutinas, progreso y rutinas predeterminadas.</p>
      </div>
    </>
  );
}
